import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import AddTopComponent from "../../CoreComponents/AddTopComponent";
import { showMessage } from "../../Functionalities/Functions";
import CategoryNameSearch from "./categoryName/CategoryNameSearch";
import CategoryPictureStep from "./categoryName/CategoryPictureStep";
import { addMenuCategory, searchCategoryName } from "./categoryName/categoryNameData";

function Body() {
  const history = useHistory();
  const [busy, setBusy] = useState(false);
  const [pictureFor, setPictureFor] = useState(null);
  const toMenus = () => history.push("/menu");

  const save = async (name, confirmNew) => {
    setBusy(true);
    const saved = await addMenuCategory({ name, confirmNew });
    setBusy(false);
    if (saved.error) showMessage(saved.error, "danger", "Failed!", "top", "top-right", 0);
    else showMessage(`${name} added`, "success", "Success!", "top", "top-right", 0);
    return !saved.error;
  };

  const add = async ({ name, confirmNew = false }) => {
    if (!(await save(name, confirmNew))) return;
    const created = await searchCategoryName(name);
    if (created.kind === "same" && !created.umbrella.image) setPictureFor(created.umbrella);
    else toMenus();
  };

  const use = async (umbrella, existing) => {
    if (!existing) {
      if (await save(umbrella.name, false)) toMenus();
      return;
    }
    showMessage(`${existing.name} is already on your menus`, "success", "Use it", "top", "top-right", 0);
    toMenus();
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <AddTopComponent path={"menu"} />
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-body">
              {pictureFor ? (
                <CategoryPictureStep umbrella={pictureFor} onDone={toMenus} />
              ) : (
                <CategoryNameSearch onUse={use} onAdd={add} busy={busy} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddMenu() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name="Add Menu" />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default AddMenu;
